<template>
  <Container>
    <template #header>
      <HeaderFe />
    </template>

    <template #hero>
      <PageHero
        :title="pageData.hero_title || pageData.label"
        :current="pageData.label"
        :subtitle="pageData.hero_subtitle || ''"
        :image="pageData.hero_image || ''"
        :color="pageData.hero_color || '#7a2f2f'"
      />
    </template>
    <template v-slot:default>
      <main class="min-h-screen pb-16 bg-gray-50">
        <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0 pt-10">
          <article
            class="p-6 prose bg-white border border-gray-100 shadow-sm sm:p-8 rounded-2xl prose-gray max-w-none"
            v-html="pageData.content || '<p class=&quot;text-gray-400&quot;>Belum ada konten.</p>'"
          ></article>
        </div>
      </main>
    </template>

    <template #footer>
      <FooterFe />
    </template>
  </Container>
</template>

<script setup>
import Container from "@/Layouts/Container.vue";
import HeaderFe from "@/Components/HeaderFe.vue";
import FooterFe from "@/Components/FooterFe.vue";
import PageHero from "@/Components/Web/PageHero.vue";

defineProps({
  pageData: { type: Object, required: true },
});
</script>
